var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.CopyBusiness"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "100%", "margin-bottom": "5px" },
          attrs: { "label-width": "120px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BLNo") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.mbl,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "mbl", $$v)
                          },
                          expression: "filter.mbl"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessNo") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.filter.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "jobNo", $$v)
                          },
                          expression: "filter.jobNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toQuery } },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "300px" },
        attrs: {
          "config-module": "12011503",
          "wrap-text": true,
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          }
        }
      }),
      _c("cargo-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0"
          }
        ],
        attrs: {
          no: "pagination",
          "config-module": "12011503",
          total: _vm.total,
          page: _vm.filter.pageNum,
          limit: _vm.filter.pageSize
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.filter, "pageNum", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.filter, "pageSize", $event)
          },
          pagination: _vm.toQuery
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.choose()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }